import { isEmpty, isNull, isNumber, isUndefined } from "underscore";

export const isEmptyNullOrUndefined = (value: any): boolean => {
  if (!isNumber(value) && isEmpty(value)) {
    return true;
  }

  if (isNumber(value) && isNull(value)) {
    return true;
  }

  if (isUndefined(value) || isNull(value)) {
    return true;
  }

  return false;
};